import { createContentPropTypes } from '../../helpers/content';

const content = {
	title: 'Payment authorisation',
	subText: 'The following users can be authorisers for this payment.',
	confirmButtonLabel: 'Continue',
	singleListHeader: 'Single Approvers',
	multiListHeader: 'Multiple Approvers',
	noUsers:
		'Sorry, there aren’t enough users with the correct permissions to authorise this payment. Please contact your corporate administrator or get in touch with us for more information.',
	noUsersTitle: 'Not enough users',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
